import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch as useDispatchOriginal, useSelector } from 'react-redux';

import { resetStore } from './slices/storeSlice';
import authReducer from './slices/authSlice';
import companyReducer from './slices/companySlice';
import tenantReducer from './slices/tenantSlice';
import productReducer from './slices/productSlice';
import schemeReducer from './slices/schemeSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  company: companyReducer,
  product: productReducer,
  scheme: schemeReducer,
  tenant: tenantReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof rootReducer>;
export type StoreDispatch = typeof store.dispatch;

export const useDispatch = () => useDispatchOriginal<StoreDispatch>();
export { useSelector, resetStore };

export default store;
